import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeroComponent } from '../../components/hero/hero.component';
import { StatsBarComponent } from '../../components/stats-bar/stats-bar.component';
import { ExpertiseComponent } from '../../components/expertise/expertise.component';
import { ServicesComponent } from '../../components/services/services.component';
import { ProjectsGalleryComponent } from '../../components/projects-gallery/projects-gallery.component';
import { WhyUsComponent } from '../../components/why-us/why-us.component';
import { ProcessJourneyComponent } from '../../components/process-journey/process-journey.component';
import { TeamTestimonialsComponent } from '../../components/team-testimonials/team-testimonials.component';
import { CtaBannerComponent } from '../../components/cta-banner/cta-banner.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    HeroComponent,
    StatsBarComponent,
    ExpertiseComponent,
    ServicesComponent,
    ProjectsGalleryComponent,
    WhyUsComponent,
    ProcessJourneyComponent,
    TeamTestimonialsComponent,
    CtaBannerComponent
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {}
